module.exports = __webpack_public_path__ + "static/media/vrml-icon.1f91d3a6.png";